"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var ObjectTypeVariables_1 = require("./ObjectTypeVariables");
var ObjectType = /** @class */ (function () {
    function ObjectType() {
    }
    ObjectType.fromJson = function (json) {
        var objectType = new ObjectType();
        objectType.model = json[Field_1.FIELD.MODEL];
        objectType.typeId = json[Field_1.FIELD.TYPEID];
        objectType.version = json[Field_1.FIELD.VERSION];
        objectType.name = json[Field_1.FIELD.NAME];
        objectType.description = json[Field_1.FIELD.DESCRIPTION];
        if (!json[Field_1.FIELD.VARIABLES]) {
            return objectType;
        }
        objectType.variables = ObjectTypeVariables_1.ObjectTypeVariables.fromJson(json[Field_1.FIELD.VARIABLES], json[Field_1.FIELD.MODEL]);
        return objectType;
    };
    ObjectType.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model;
        json[Field_1.FIELD.TYPEID] = this.typeId;
        json[Field_1.FIELD.VERSION] = this.version;
        json[Field_1.FIELD.NAME] = this.name;
        json[Field_1.FIELD.DESCRIPTION] = this.description;
        if (this.variables) {
            json[Field_1.FIELD.VARIABLES] = this.variables.toJson();
            return json;
        }
        json[Field_1.FIELD.VARIABLES] = {};
        return json;
    };
    return ObjectType;
}());
exports.ObjectType = ObjectType;
//# sourceMappingURL=ObjectType.js.map